module.exports = __webpack_public_path__ + "img/pop_wallet_logo_sollet@2x.13ebbda5.png";